const kolor = { t: 'Kolor', name: 'kolor', hint: { url: '/color' }}
export default kolor